export const DefaultModel = {
  isOpen: false
};

export const Action = {
  OPEN: `OPEN`,
  CLOSE: `CLOSE`
};

export const TIMEOUT_TIME = 100;
